function AboutUs() {
  return (
    <div>
      <div className="about-first-section">
        <div className="about-first">Who Are We?</div>
        <div className="about-first-text">
          We are a limited liability company with RC 1772231 dealing in
          furniture and interior design, born out of the desire to create a feel
          of elegance to the contemporary African homes and Offices with the
          best available quality at competitive price.
        </div>
        <div className="about-first-text">
          This explains why we are located at the heart and capital hub of
          African Art; Benin City, Nigeria. At Cyooner we believe furniture is
          more than just aesthetics, it is a place where the future is designed
          (school), products are birth(company), negotiations are made
          (Conference rooms) and bonds are created (home).
        </div>
        <div className="chair-div">
          <img
            src="https://res.cloudinary.com/dynmdbdfu/image/upload/v1699029820/Screenshot_2023-11-03_174208-removebg-preview_dwfquz.png"
            className="chair-about-img"
          />
        </div>
        <div className="about-second-section">
          Our products/services range from making and fixing couches, Bed
          frames, kitchen cabinets, dining sets, office tables, Bookshelf, TV
          Console etc. and for your Estate, Hotel, Home, and Office.
        </div>
        <div className="team-heading">Our Team</div>
        <div className="about-third-section">
          Our team of carpenters have wide experience spanning two decades
          within and outside the shores of Nigeria. Location is not a barrier as
          we have a team that moves on demand. To ensure safe delivery of your
          furniture/design for our online customers within and outside Nigeria,
          we are in partnership with a reputable domestic/international
          coordination company to aid in that regard for items that are outside
          the scope of the company delivery van.
        </div>
        <div className="mission-div">Our Mission</div>
        <div className="about-first-text">
          Our mission at Cyooner is to make qualitative furniture and interiors
          that create a feel of elegance in your home and office.
        </div>
        <div className="mission-div">Our Vision</div>
        <div className="about-last-text">
          Our vision at Cyooner is to revolutionize the Nigerian furniture and
          interior design industry and become a centerpiece of its innovation
          while producing qualitative products for your home and office.
        </div>
      </div>
    </div>
  );
}
export default AboutUs;
